import React from "react";
import {Link} from "react-router-dom";
import SeoMeta from "../../components/SeoMeta";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import heroImage from "../../assets/images/titleImage.png";
import lowestPrice from "../../assets/images/lowestPrice.png";
import s from "./LowestPriceGuarantee.module.scss";
import {
    ArrowForwardIosOutlined,
    DiamondOutlined,
    FavoriteBorderOutlined,
    InsertCommentOutlined,
    LocalPostOfficeOutlined,
    PeopleAltOutlined, SavingsOutlined,
    VerifiedUserOutlined
} from "@mui/icons-material";

const LowestPriceGuarantee = () => {
    const breadcrumbItems = [
        {
            name: "ホーム",
            link: "/"
        },
        {
            name: "どこよりも低価格保証"
        }
    ];

    return (
        <>
            <SeoMeta
                slug={window.location.pathname}
                fallback={{
                    title: "どこよりも低価格保証",
                    description:
                        "ケアンズで最安値に挑戦。他よりも高かったらお気軽にご相談ください。",
                    image: "",
                    url: `${process.env.REACT_APP_URL}${window.location.pathname}`
                }}
            />

            <div className={s.page}>

                <div className={s.breadcrumb}>
                    <Breadcrumb items={breadcrumbItems}/>
                </div>

                {/* HERO */}
                <section
                    className={s.hero}
                    style={{
                        backgroundImage: `url(${heroImage})`
                    }}
                >
                    <div className={s.overlay}></div>

                    <div className={s.heroContent}>

                        <div className={s.smallTitle}>
                            ♕ ケアンズで最安値
                        </div>

                        <h1 className={s.header}>
                            どこよりも低価格保証 <br/>
                            <span className={s.subHeader}>他よりも高かったら、お気軽にご相談ください。</span>
                        </h1>
                        <div className={s.line}
                        ></div>

                        <p>
                            オーストラリア·ケアンズで一番価格の自信があります!
                            <br/>
                            営業会社を間に挟んでいないので、<br/>
                            他社より価格を抑えることが可能です。<br/>
                            もし1円でも高ければお気軽にご相談ください!
                        </p>

                    </div>

                    <div className={s.guarantee}>
                        <i className="fa fa-tags" aria-hidden="true"></i>

                        <span>
                            PRICE
                            <br/>
                            GUARANTEE
                        </span>
                    </div>

                </section>

                {/* INTRO */}
                <section className={s.intro}>

                    <div className={s.headingWithLines}>
                        <span></span>
                        <h2>私たちが最安値を実現できる理由</h2>
                        <span></span>
                    </div>
                    <div className={s.reasonGrid}>


                        <div className={s.reason}>
                            <div className={s.reasonIcon}>
                                <PeopleAltOutlined/>
                            </div>
                            <h3>
                                営業会社を通さない
                            </h3>
                            <p>
                                余計な中間マージンが発生しないため、<br/>
                                その分をお客様へ還元できます。
                            </p>
                        </div>

                        <div className={s.reason}>
                            <div className={s.reasonIcon}>
                                <SavingsOutlined/>
                            </div>
                            <h3>
                                コストを最小限に
                            </h3>
                            <p>
                                現地運営に特化することで、<br/>
                                無駄なコストを徹底的に削減。
                            </p>
                        </div>

                        <div className={s.reason}>
                            <div className={s.reasonIcon}>
                                <DiamondOutlined/>
                            </div>
                            <h3>
                                高品質なツアーを低価格で
                            </h3>
                            <p>
                                品質は妥協せず、<br/>
                                安心・安全なツアーをご提供します。
                            </p>
                        </div>

                    </div>

                </section>

                {/* GUARANTEE BOX */}
                <section className={s.guaranteeBox}>

                    <div className={s.badge}>
                        <img src={lowestPrice}/>
                    </div>
                    <div className={s.guaranteeBoxWordWrapper}>
                        <h2>
                            もし他社より1円でも高い場合はご相談ください!
                        </h2>

                        <p>
                            同じ内容のツアーで、当サイトよりも安い価格を見つけた場合は、 <br/>

                            お気軽にご連絡ください。内容を確認のうえ、できる限り価格を調整いたします。
                        </p>
                        <div className={s.pointSection}>
                            <ul>
                                <li>
                                    同一または同等内容のツアーが対象となります。
                                </li>
                                <li>
                                    時期·空き状況·条件により対応できない場合がございます。
                                </li>
                                <li>
                                    他の割引やキャンペーンとの併用はできません。
                                </li>
                            </ul>
                        </div>
                    </div>

                </section>

                {/* CTA */}
                <section className={s.cta}>

                    <h2>
                        <InsertCommentOutlined/> 他社の価格が気になる方は、お気軽にご相談ください!
                    </h2>

                    <Link
                        to="/contact"
                        className={s.button}
                    >
                        <LocalPostOfficeOutlined/> 価格について相談する
                        <ArrowForwardIosOutlined/>
                    </Link>

                    <p>
                        お問い合わせは24時間受付中です
                    </p>

                </section>

                {/* TRUST */}
                <section className={s.trust}>

                    <div className={s.trustContainer}>
                        <div className={s.icon}>
                            <VerifiedUserOutlined/>
                        </div>
                        <div>
                            <strong>
                                安心·安全のツアー
                            </strong>
                            <p>
                                現地在住の日本人スタッフが <br/>
                                しっかりサポート。 <br/>
                                初めての方でも安心です。
                            </p>
                        </div>
                    </div>

                    <div className={s.trustContainer}>
                        <div  className={s.icon}>
                            <PeopleAltOutlined/>
                        </div>
                        <div >
                            <strong>
                                日本語ガイド付き
                            </strong>
                            <p>
                                すべてのツアーが日本語対応。<br/>
                                言業の心配なくお楽しみ<br/>
                                いただけます。
                            </p>
                        </div>
                    </div>

                    <div className={s.trustContainer}>
                        <div className={s.icon}>
                            <FavoriteBorderOutlined/>
                        </div>
                        <div>
                            <strong>
                                お客様満足度No.1を目指して
                            </strong>
                            <p>
                                価格だけでなく、思い出に残る <br/>
                                最高の体験をお届けします。
                            </p>
                        </div>
                    </div>


                </section>
                <div className={s.condition}>
                    <p>  ※表示価格はすべて税込(GST込み)です。</p>
                </div>
            </div>
        </>
    );
};
const Reason = ({icon = "", iconname = "", title, text}) => (
    <div className={s.reason}>
        <div className={s.reasonIcon}>
            {icon ? < i className={`${icon}`} aria-hidden="true"></i> : `${iconname}`}
        </div>
        <h3>
            {title}
        </h3>
        <p>
            {text}
        </p>
    </div>
);
export default LowestPriceGuarantee;